import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

import { filterFalsy } from 'common/helpers'
import { Logger } from 'common/log'
import { MediaFile, MediaFileBundle, MediaRootPermission } from 'elements-sdk'
import { isBundle } from 'media/helpers'

import { MediaPermissionsService } from './mediaPermissions.service'

export type SelectionItem = MediaFileBundle|MediaFile

@Injectable({ providedIn: 'root' })
export class MediaBrowserSelection {
  logger = new Logger(__filename)
  bundles: MediaFileBundle[] = []
  dirs: MediaFile[] = []
  commonPermission: MediaRootPermission
  change$ = new Subject<void>()
  private _lists: SelectionItem[][] = [this.bundles, this.dirs]

  constructor (private mediaPermissions: MediaPermissionsService) {
    'ngInject'
    this.mediaPermissions = mediaPermissions
    this.updateCommonPermission()
  }

  clear (): void {
    for (const l of this._lists) {
      l.length = 0
    }
    this.updateCommonPermission()
    this.change$.next()
  }

  total (): number {
    return this.bundles.length + this.dirs.length
  }

  hasSelection (): boolean {
    return this.total() > 0
  }

  isSelected (item: SelectionItem): boolean {
    return this._lists.some(list =>
      list.some(i => i.id === item.id && isBundle(i) === isBundle(item)))
  }

  toggleSelected (item: SelectionItem|SelectionItem[], forceSelection?: boolean): void {
    if (item instanceof Array) {
      for (const single of item) {
        this.toggleSelected(single, forceSelection)
      }
    } else {
      if ((this.isSelected(item) && (forceSelection !== true)) || forceSelection === false) {
        for (const l of this._lists) {
          for (const i of l.slice(0)) {
            if (i.id === item.id && isBundle(i) === isBundle(item)) {
              // remove from array
              l.splice(l.indexOf(i), 1)
              this.logger.debug('[mediaBrowserSelection] unselecting', item)
            }
          }
        }
      } else {
        this.logger.debug('[mediaBrowserSelection] selecting', item)
        if (isBundle(item)) {
          this.bundles.push(item)
        } else {
          this.dirs.push(item)
        }
      }
    }
    this.updateCommonPermission()
    this.change$.next()
  }

  updateCommonPermission (): void {
    this.commonPermission = this.mediaPermissions.mergePermissions([
      ...filterFalsy(this.dirs.map(d => this.mediaPermissions.getPermissionForFile(d))),
      ...filterFalsy(this.bundles.map(b => this.mediaPermissions.getPermissionForBundle(b))),
    ])
  }
}
